import React from 'react';
import AppRoutes from './routes/appRoutes';
import GlobalStyles from './GlobalStyles';
import { AppThemeProvider } from './shared/contexts/AppThemeProvider';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/login/SinginProvider';
import { EnvBadge } from './shared/components/EnvBadge';

const App = () => {
  return (
    <React.Fragment>
      <AppThemeProvider>
        <GlobalStyles />
        <EnvBadge />
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </AppThemeProvider>
    </React.Fragment>
  );
};

export default App;
